var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReachedPickup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.379,
    height: 21.97,
    viewBox: "0 0 15.379 21.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    "data-name": "Icon material-location-on",
    d: "M15.189,3A7.684,7.684,0,0,0,7.5,10.689c0,5.767,7.689,14.28,7.689,14.28s7.689-8.513,7.689-14.28A7.684,7.684,0,0,0,15.189,3Zm0,10.436a2.746,2.746,0,1,1,2.746-2.746A2.747,2.747,0,0,1,15.189,13.436Z",
    transform: "translate(-7.5 -3)",
    fill: "#5650ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReachedPickup);
export default __webpack_public_path__ + "static/media/reached_pickup.3c70bc5408e4883f58426a9b43ac993e.svg";
export { ForwardRef as ReactComponent };